/**
 * CreateIdeaModal Styles
 * Extracted per Cursor Rules (<300 lines per file)
 */

import { StyleSheet } from 'react-native';
import { color, text, space, radius, icon, touch } from '../../../../shared/tokens/mobile';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: color.background,
  },
  
  // Header
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: space.md,
    paddingVertical: space.sm,
    borderBottomWidth: 1,
    borderBottomColor: color.border,
    backgroundColor: color.surface,
  },
  closeButton: {
    width: touch.minimum,
    height: touch.minimum,
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerTitle: {
    fontSize: text.sectionTitle.fontSize,
    fontWeight: text.sectionTitle.fontWeight,
    color: color.textPrimary,
  },
  createButton: {
    backgroundColor: color.primary,
    paddingHorizontal: space.lg,
    paddingVertical: space.sm,
    borderRadius: radius.md,
    minWidth: 70,
    alignItems: 'center',
  },
  createButtonDisabled: {
    backgroundColor: color.disabled,
  },
  createButtonText: {
    fontSize: text.body.fontSize,
    fontWeight: '600',
    color: color.surface,
  },
  
  // Scroll
  scroll: {
    flex: 1,
  },
  scrollContent: {
    padding: space.md,
    gap: space.lg,
  },
  
  // Error
  errorBanner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: space.sm,
    padding: space.md,
    backgroundColor: color.errorLight,
    borderRadius: radius.md,
  },
  errorText: {
    fontSize: text.body.fontSize,
    color: color.error,
    flex: 1,
  },
  
  // Fields
  field: {
    gap: space.sm,
  },
  label: {
    fontSize: text.caption.fontSize,
    fontWeight: '600',
    color: color.textSecondary,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  titleInput: {
    backgroundColor: color.surface,
    borderWidth: 1,
    borderColor: color.border,
    borderRadius: radius.md,
    padding: space.md,
    fontSize: text.body.fontSize,
    color: color.textPrimary,
  },
  descriptionInput: {
    backgroundColor: color.surface,
    borderWidth: 1,
    borderColor: color.border,
    borderRadius: radius.md,
    padding: space.md,
    fontSize: text.body.fontSize,
    color: color.textPrimary,
    minHeight: 100,
  },
  
  // Options
  optionsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: space.sm,
  },
  optionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: space.xs,
    paddingHorizontal: space.md,
    paddingVertical: space.sm,
    backgroundColor: color.surface,
    borderWidth: 1,
    borderColor: color.border,
    borderRadius: radius.md,
  },
  optionLabel: {
    fontSize: text.body.fontSize,
    color: color.textSecondary,
  },
  
  // Priority
  priorityRow: {
    flexDirection: 'row',
    gap: space.sm,
  },
  priorityButton: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: space.xs,
    paddingVertical: space.md,
    backgroundColor: color.surface,
    borderWidth: 1,
    borderColor: color.border,
    borderRadius: radius.md,
  },
  priorityDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
  },
  priorityLabel: {
    fontSize: text.caption.fontSize,
    color: color.textSecondary,
  },
});

